import {RouterModule, Routes} from '@angular/router';
import {NgModule} from '@angular/core';
import {LorenPasswordResetComponent} from './components/loren-password-reset/loren-password-reset.component';
import {LorenLoginGuard} from '../loren-login/guards/loren-login-guard/loren-login-guard.service';
import {LorenPasswordResetTokenResolver} from './resolvers/loren-password-reset-token.resolver';
import {LOREN_ROUTER_OUTLETS} from '../../shared/constants/loren-router-outlets.constants';

const routes: Routes = [
    {
        path: '',
        canActivate: [
            LorenLoginGuard
        ],
        resolve: {
            token: LorenPasswordResetTokenResolver
        },
        component: LorenPasswordResetComponent,
        outlet: LOREN_ROUTER_OUTLETS.LOGIN,
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class LorenPasswordResetRoutingModule {
}
